import * as React from 'react';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { MobileTimePicker } from '@mui/x-date-pickers';

const useStyles = makeStyles((theme) => ({
    calender: {
        "& div": {
            fontSize: "1.4rem !important",
        },
        "& span": {
            fontSize: "1.4rem !important",
        },
        "& button": {
            fontSize: "1.4rem !important",
        },
    },
    datePicker: {
        "flex-direction": "row-reverse",
        fontSize: "1.4rem !important",
        "& fieldSet": {
            border: "none",
        },
        // marginTop: "0.6rem",
        width: "100%",
        background: "#F2F4F7",
        border: "1px solid #F2F4F7 !important",
        boxSizing: "border-box",
        boxShadow: "0px 1px 2px rgb(16 24 40 / 5%)",
        borderRadius: "0.8rem",
        "& input": {
            width: "100%",
            fontSize: "1.4rem !important",
            padding: "1rem 1.4rem !important",
            color: "#667085"
        },
        "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #84CAFF !important",
                boxShadow:
                    "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important",
            },
        },
        "&:hover": {
            // border:"none",
            "& .MuiOutlinedInput-notchedOutline": {
                // border: '1px solid #D0D5DD !important'
            },
        },
    },
    helperText: {
        fontSize: "1.4rem !important",
        margin: "0.2rem 0 0 0 !important",
        fontFamily: 'Inter-Medium !important',
        color: "#d32f2f !important"
    },
    label: {
        fontFamily: 'Inter-Regular',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '1.4rem',
        lineHeight: '2rem',
        color: '#344054',
        marginBottom: "0.6rem"
    }
}));

export default function TimeComponent({ helperText, onChangeTime, value, label = '' }) {
    const classes = useStyles();

    return (
        <div className={classes.mainContainer}>
            <div className={classes.label}>
                <p>{label}</p>
            </div>
            <div className={classes.input}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileTimePicker
                        value={value}
                        onChange={(e) => e ? onChangeTime(e['$d']) : onChangeTime('')}
                        PaperProps={{ className: classes.calender }}
                        DialogProps={{ className: classes.calender }}
                        PopperProps={{ placement: "bottom-start" }}
                        InputProps={{
                            className: classes.datePicker,
                            endAdornment: (
                                <InputAdornment position="start">
                                    <AccessTimeIcon
                                        style={{ fontSize: '2rem', marginLeft: '1.5rem', cursor: "pointer", color: "#667085" }}
                                    />
                                </InputAdornment>
                            )
                        }}
                        renderInput={(params) => (
                            <TextField
                                style={{ verticalAlign: "middle" }}
                                placeholder='00:00'
                                {...params}
                                helperText={helperText}
                                FormHelperTextProps={{
                                    classes: {
                                        root: classes.helperText,
                                    },
                                }}
                                sx={[
                                    {
                                        "&>div:first-of-type": {
                                            border: helperText !== "" ? "1px solid red !important" : "1px solid #F2F4F7 !important",
                                            borderRadius: "0.8rem",
                                        },
                                        width: "100%",
                                    },
                                ]}
                            />
                        )}
                    />
                </LocalizationProvider>
            </div>
        </div>
    );
}
